import { useEffect } from 'react';
import { useSearchParams, Navigate, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import ProfileSelection from './ProfileSelection';

const SBSearchTermReportIndex = () => {
  const [searchParams] = useSearchParams();
  
  // Check if this is an OAuth callback with query parameters
  const success = searchParams.get('success');
  const step = searchParams.get('step');
  
  // If we have OAuth callback parameters, redirect to profile selection
  if (success && step === 'profile_selection') {
    return <Navigate to="profile-selection" replace />;
  }
  
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="profile-selection" element={<ProfileSelection />} />
    </Routes>
  );
};

export default SBSearchTermReportIndex;